export class DataHolderVo {
    feeds:any = [];
    jobOpenings:any = [];
    questions:any = [];
}